'use strict';

angular.module('licensure.services')
    .factory('IPDeficiencies', ['$http', '$q', function ($http, $q) {

        return {

            get: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPDeficiencies', {
                    params: {
                        
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPDeficiencies/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (deficiency) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/IPDeficiencies/';
                if (!isUndefined(deficiency.id)) {
                    method = 'PUT'
                    url += deficiency.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        deficiency: deficiency
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/IPDeficiencies/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }])
;